/* unplugin-vue-components disabled */import script from "./JsonYaml.vue?vue&type=script&setup=true&lang=js"
export * from "./JsonYaml.vue?vue&type=script&setup=true&lang=js"

import "./JsonYaml.vue?vue&type=style&index=0&id=36475ee6&lang=scss"

const __exports__ = script;

export default __exports__